import { useTranslation } from 'next-i18next';
import React, { memo } from 'react';
import { Box } from '@mui/material';
import { BaseButton, BaseAvatar, BasePlate, BasePlateHeader } from '@evrone-erp/uikit';
import type { TUser } from '@entities/user/lib/types';
import { styles } from './styles';
import { absolutePathImageLoader } from '@shared';
export interface IPhotoProps {
  onClick: () => void;
  avatar?: TUser['avatar'];
  title?: string;
  isLoading?: boolean;
}
const EDITOR_AVATAR_SIZE = 180;
export const Photo = memo(({
  onClick,
  avatar,
  title,
  isLoading
}: IPhotoProps) => {
  const {
    t
  } = useTranslation(['account', 'translation']);
  const defaultTitle = t('account:photo');
  return <BasePlate sx={styles.root} onClick={onClick} loading={isLoading}>
      <Box sx={styles.content}>
        <BasePlateHeader title={title || defaultTitle} sx={styles.header} />
        <BaseButton sx={{
        ml: '-4px'
      }} variant="text" icon="plus">
          {t('translation:update')}
        </BaseButton>
      </Box>
      <BaseAvatar sx={styles.avatar} value={avatar?.normal} size={EDITOR_AVATAR_SIZE} placeholder={t('account:photoPlaceholder')} imageLoader={absolutePathImageLoader} />
    </BasePlate>;
});